import { render } from "./SdekModalWindow.vue?vue&type=template&id=ab29773c"
import script from "./SdekModalWindow.vue?vue&type=script&lang=js"
export * from "./SdekModalWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__